/**
 * Composable for menu path utilities
 * Provides reusable path checking functions
 */
export function useMenuPath() {
  /**
   * Check if path is an edit campaign path
   * @param path - Route path to check
   * @returns true if path matches edit campaign pattern
   */
  function isEditCampaignPath(path: string): boolean {
    return /^\/campaigns\/edit\/\d+$/.test(path)
  }

  return {
    isEditCampaignPath
  }
}








